export const scopes = {
  edit: 'student-evaluation-history.edit',
};
